<template>
  <div class="test-panel" :class="{ collapsed: isCollapsed }">
    <div class="test-panel-header">
      <div v-if="!isCollapsed" class="test-panel-title-section">
        <img  src="@/assets/MyWorkBench/Workflow/patient_default_icon.svg"/>
        <span  class="test-panel-title">Test Workflow Execution</span>
      </div>
      <button class="collapse-btn" @click="togglePanel">
        <img
          v-if="isCollapsed"
          src="@/assets/MyWorkBench/Workflow/test_panel_expand.svg"
        />
        <img
          v-else
          src="@/assets/MyWorkBench/Workflow/test_panel_collapse.svg"
        />
      </button>
    </div>

    <div v-if="!isCollapsed" class="test-panel-content">
      <!-- Tabs -->
      <div class="tabs-container">
        <button 
          class="tab-button" 
          :class="{ active: activeTab === 'testRun' }"
          @click="activeTab = 'testRun'"
        >
          <svg viewBox="0 0 18 18" width="18px" height="18px" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 15C2.5875 15 2.23437 14.8531 1.94062 14.5594C1.64687 14.2656 1.5 13.9125 1.5 13.5V4.5C1.5 4.0875 1.64687 3.73438 1.94062 3.44063C2.23437 3.14688 2.5875 3 3 3H10.5V4.5H3V13.5H15V9H16.5V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15H3ZM7.5375 12.2812L6.4875 11.2125L8.7 9H7.0125V7.5H11.25V11.7375H9.75V10.0688L7.5375 12.2812ZM14.25 7.5C13.625 7.5 13.0937 7.28125 12.6562 6.84375C12.2187 6.40625 12 5.875 12 5.25C12 4.625 12.2187 4.09375 12.6562 3.65625C13.0937 3.21875 13.625 3 14.25 3C14.875 3 15.4062 3.21875 15.8437 3.65625C16.2812 4.09375 16.5 4.625 16.5 5.25C16.5 5.875 16.2812 6.40625 15.8437 6.84375C15.4062 7.28125 14.875 7.5 14.25 7.5Z" :fill="activeTab === 'testRun' ? '#004879' : '#666666'"/>
          </svg>
          <span>Test Run</span>
        </button>
        <button 
          class="tab-button" 
          :class="{ active: activeTab === 'logView' }"
          @click="activeTab = 'logView'"
        >
          <svg viewBox="0 0 18 18" width="18px" height="18px" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 13.5V12H8.6625L10.6313 9.75L8.6625 7.5H7.425L6.225 13.95C6.125 14.5125 5.89375 14.9531 5.53125 15.2719C5.16875 15.5906 4.70625 15.75 4.14375 15.75C3.58125 15.75 3.125 15.6 2.775 15.3C2.425 15 2.25 14.6 2.25 14.1C2.25 13.7 2.35625 13.3781 2.56875 13.1344C2.78125 12.8906 3.05 12.7688 3.375 12.7688C3.6875 12.7688 3.95312 12.875 4.17187 13.0875C4.39062 13.3 4.5 13.5563 4.5 13.8563C4.5 13.9188 4.49687 13.975 4.49062 14.025C4.48437 14.075 4.475 14.1313 4.4625 14.1938C4.525 14.1813 4.57812 14.1469 4.62187 14.0906C4.66562 14.0344 4.7 13.9563 4.725 13.8563L5.8875 7.5H3.75V6H6.16875L6.5625 3.8625C6.65 3.3875 6.88437 3 7.26562 2.7C7.64687 2.4 8.1 2.25 8.625 2.25C9.175 2.25 9.625 2.4125 9.975 2.7375C10.325 3.0625 10.5 3.46875 10.5 3.95625C10.5 4.33125 10.3938 4.64062 10.1813 4.88437C9.96875 5.12812 9.7 5.25 9.375 5.25C9.0625 5.25 8.79688 5.14375 8.57813 4.93125C8.35937 4.71875 8.25 4.45625 8.25 4.14375C8.25 4.08125 8.25312 4.025 8.25938 3.975C8.26563 3.925 8.275 3.86875 8.2875 3.80625C8.2125 3.83125 8.15625 3.86875 8.11875 3.91875C8.08125 3.96875 8.05 4.04375 8.025 4.14375L7.70625 6H11.25V7.5H10.65L11.625 8.60625L12.6 7.5H12V6H15.75V7.5H14.5875L12.6188 9.75L14.5875 12H15.75V13.5H12V12H12.6L11.625 10.875L10.65 12H11.25V13.5H7.5Z" :fill="activeTab === 'logView' ? '#004879' : '#666666'"/>
          </svg>
          <span>Log View</span>
        </button>
      </div>

      <!-- Test Run Tab -->
      <div v-if="activeTab === 'testRun'" class="test-run-tab">
        <p class="test-description">Test Execution runs the current workflow with dummy patients data to verify functionality.</p>
        
        <!-- Current Test Status Table -->
        <div v-if="currentTest" class="test-history-table">
          <div class="table-body">
            <div class="table-row">
              <div class="table-cell timestamp">{{ currentTest.timestamp }}</div>
              <div class="table-cell test-type">
                <span class="type-chip" :class="currentTest.type">{{ currentTest.type === 'live' ? 'Live Run' : 'Test Run' }}</span>
              </div>
              <div class="table-cell status">
                <div class="status-indicator" :class="currentTest.status">
                  <svg v-if="currentTest.status === 'running'" class="status-icon spinning" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 2C4.68 2 2 4.68 2 8C2 11.32 4.68 14 8 14C11.32 14 14 11.32 14 8" stroke="#374957" stroke-width="2"/>
                  </svg>
                  <svg v-else-if="currentTest.status === 'success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 10L3.5 7.5L4.5 6.5L6 8L9.5 4.5L10.5 5.5L6 10Z" fill="#45960D"/>
                  </svg>
                  <svg v-else-if="currentTest.status === 'failed'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L11 3L8 6L5 3L4 4L7 7L4 10L5 11L8 8L11 11L12 10L9 7L12 4Z" fill="#D10000"/>
                  </svg>
                  <span>{{ getStatusLabel(currentTest.status) }}</span>
                </div>
              </div>
              <div class="table-cell duration">{{ currentTest.duration }}</div>
            </div>
          </div>
        </div>

        <!-- Test Steps -->
        <div class="test-steps-container">
          <!-- Overall Status Message -->
          <div v-if="overallStatus" class="status-message" :class="overallStatus.type">
            <div class="status-message-content">
              <svg v-if="overallStatus.type === 'success'" class="status-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="#45960D"/>
              </svg>
              <svg v-else-if="overallStatus.type === 'running'" class="status-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#374957"/>
              </svg>
              <svg v-else-if="overallStatus.type === 'error'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#D10000"/>
              </svg>
              <div class="status-message-text">
                <p class="status-message-title">{{ overallStatus.title }}</p>
                <p class="status-message-description">{{ overallStatus.description }}</p>
              </div>
            </div>
          </div>

          <div v-if="testSteps.length > 0" class="divider"></div>

          <!-- Test Steps List -->
          <div class="test-steps-list">
            <div 
              v-for="(step, index) in testSteps" 
              :key="index" 
              class="test-step" 
              :class="step.status"
            >
              <div class="step-content">
                <svg v-if="step.status === 'running'" class="step-icon spinning" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12" stroke="#374957" stroke-width="2"/>
                </svg>
                <svg v-else-if="step.status === 'success'" class="step-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="#45960D"/>
                </svg>
                <svg v-else-if="step.status === 'failed'" class="step-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#D10000"/>
                </svg>
                <div class="step-text">
                  <p class="step-title">{{ step.title }}</p>
                  <p class="step-description">{{ step.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Log View Tab -->
      <div v-if="activeTab === 'logView'" class="log-view-tab">
        <!-- Filters -->
        <div class="filters-row">
          <div class="filter-group">
            <Label label="Test Type:" :required="false">
              <SingleSelector
                v-model="filters.testType"
                size="small"
                placeholder="All"
                :options="testTypeOptions"
              />
            </Label>
          </div>
          <div class="filter-group">
            <Label label="Status:" :required="false">
              <SingleSelector
                v-model="filters.status"
                size="small"
                placeholder="All"
                :options="statusOptions"
              />
            </Label>
          </div>
          <div class="filter-group">
            <Label label="Time Range:" :required="false">
              <SingleSelector
                v-model="filters.timeRange"
                size="small"
                placeholder="Last 7 days"
                :options="timeRangeOptions"
              />
            </Label>
          </div>
        </div>

        <!-- Test History Table -->
        <div class="test-history-table">
          <div class="table-header">
            <div class="table-cell timestamp">Timestamp</div>
            <div class="table-cell test-type">Test Type</div>
            <div class="table-cell status">Status</div>
            <div class="table-cell duration">Duration</div>
            <div class="table-cell details">Details</div>
          </div>
          <div class="table-body">
            <div v-for="(test, index) in filteredTestHistory" :key="index" class="table-row">
              <div class="table-cell timestamp">{{ test.timestamp }}</div>
              <div class="table-cell test-type">
                <span class="type-chip" :class="test.type">{{ test.type === 'live' ? 'Live Run' : 'Test Run' }}</span>
              </div>
              <div class="table-cell status">
                <div class="status-indicator" :class="test.status">
                  <svg v-if="test.status === 'running'" class="status-icon spinning" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 2C4.68 2 2 4.68 2 8C2 11.32 4.68 14 8 14C11.32 14 14 11.32 14 8" stroke="#374957" stroke-width="2"/>
                  </svg>
                  <svg v-else-if="test.status === 'success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 10L3.5 7.5L4.5 6.5L6 8L9.5 4.5L10.5 5.5L6 10Z" fill="#45960D"/>
                  </svg>
                  <svg v-else-if="test.status === 'failed'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L11 3L8 6L5 3L4 4L7 7L4 10L5 11L8 8L11 11L12 10L9 7L12 4Z" fill="#D10000"/>
                  </svg>
                  <span>{{ getStatusLabel(test.status) }}</span>
                </div>
              </div>
              <div class="table-cell duration">{{ test.duration }}</div>
              <div class="table-cell details">
                <button class="view-details-btn" @click="viewTestDetails(test)">View Details</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination-container">
          <div class="w-1/5"></div>
          <div class="w-3/5 pagination-controls">
            <button class="pagination-btn" :disabled="currentPage === 1" @click="currentPage--">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M8 2L4 6L8 10" stroke="#374957" stroke-width="2"/>
              </svg>
            </button>
            <button 
              v-for="page in visiblePages" 
              :key="page" 
              class="pagination-number" 
              :class="{ active: page === currentPage }"
              @click="currentPage = page"
            >
              {{ page }}
            </button>
            <span v-if="totalPages > 5" class="pagination-ellipsis">...</span>
            <button class="pagination-btn" :disabled="currentPage === totalPages" @click="currentPage++">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M4 2L8 6L4 10" stroke="#374957" stroke-width="2"/>
              </svg>
            </button>
          </div>
          <div class="w-1/5 items-per-page">
            <SingleSelector
              v-model="itemsPerPage"
              size="medium"
              :options="itemsPerPageOptions"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowTestPanel',

  props: {
    currentWorkflow: {
      type: String,
      default: ''
    },
    isRunning: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isCollapsed: true,
      activeTab: 'testRun',
      currentTest: null,
      overallStatus: null,
      testSteps: [],
      testStartTime: null,
      filters: {
        testType: 'all',
        status: 'all',
        timeRange: '7d'
      },
      testHistory: [],
      currentPage: 1,
      itemsPerPage: 5,
      // Workflow instances data (loaded from API)
      workflowInstances: [],
      totalInstances: 0, // Total count from API for pagination
      isLoadingInstances: false,
      // Options for SingleSelector components
      testTypeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Test Run', value: 'test' },
        { label: 'Live Run', value: 'live' }
      ],
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Running', value: 'running' },
        { label: 'Success', value: 'success' },
        { label: 'Failed', value: 'failed' }
      ],
      timeRangeOptions: [
        { label: 'Last 7 days', value: '7d' },
        { label: 'Last 30 days', value: '30d' },
        { label: 'Last 90 days', value: '90d' }
      ],
      itemsPerPageOptions: [
        { label: '5 per page', value: 5 },
        { label: '10 per page', value: 10 },
        { label: '20 per page', value: 20 }
      ]
    };
  },

  computed: {
    filteredTestHistory() {
      // When using workflowInstances (from API), they are already paginated
      // Just return them directly
      if (this.workflowInstances.length > 0) {
        return this.workflowInstances;
      }

      // For testHistory (legacy/client-side data), use client-side filtering
      let filtered = this.testHistory;

      if (this.filters.testType !== 'all') {
        filtered = filtered.filter(test => {
          const isLive = test.type === 'live' || test.is_live;
          return this.filters.testType === 'live' ? isLive : !isLive;
        });
      }

      if (this.filters.status !== 'all') {
        filtered = filtered.filter(test => {
          const status = test.status;
          if (this.filters.status === 'success') {
            return status === 'success' || status === 'completed';
          }
          if (this.filters.status === 'failed') {
            return status === 'failed' || status === 'error';
          }
          return status === this.filters.status;
        });
      }

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return filtered.slice(start, end);
    },

    totalPages() {
      // When using workflowInstances from API, use totalInstances from server
      if (this.workflowInstances.length > 0 || this.totalInstances > 0) {
        return Math.ceil(this.totalInstances / this.itemsPerPage);
      }
      // For testHistory, use client-side calculation
      return Math.ceil(this.testHistory.length / this.itemsPerPage);
    },
    
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.totalPages, start + maxVisible - 1);
      
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },

  watch: {
    isRunning(newVal) {
      if (newVal) {
        this.startTest();
      }
    },
    activeTab(newVal) {
      if (newVal === 'logView') {
        this.loadWorkflowInstances();
      }
    },
    currentPage() {
      // Reload instances when page changes (only if in logView)
      if (this.activeTab === 'logView') {
        this.loadWorkflowInstances();
      }
    },
    itemsPerPage() {
      // Reload instances when page size changes (only if in logView)
      if (this.activeTab === 'logView') {
        this.currentPage = 1; // Reset to first page when changing page size
        this.loadWorkflowInstances();
      }
    },
    'filters.status'() {
      // Reload instances when status filter changes (only if in logView)
      if (this.activeTab === 'logView') {
        this.currentPage = 1; // Reset to first page when changing filter
        this.loadWorkflowInstances();
      }
    }
  },
  
  created() {
    // Import notify for potential use
    import('@/utils/notify').then(module => {
      this.notify = module.default || module.notify;
    });
  },

  methods: {
    async callTestApi() {
      try {
        const { testWorkflowApi } = await import('@/api/workflowManage');
        const response = await testWorkflowApi(this.$route.params.workflowId, {});
        return response.data || response;
      } catch (error) {
        console.error('Test API error:', error);
        throw error;
      }
    },
    togglePanel() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('toggle', !this.isCollapsed);
    },
    
    async startTest() {
      this.isCollapsed = false;
      this.activeTab = 'testRun';
      
      // Clear previous test data
      this.clearTestData();
      
      // Record test start time
      this.testStartTime = Date.now();
      
      this.currentTest = {
        timestamp: new Date().toLocaleString('en-US', { 
          month: '2-digit', 
          day: '2-digit', 
          year: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit' 
        }),
        type: 'test',
        status: 'running',
        duration: '0s'
      };
      
      this.overallStatus = {
        type: 'running',
        title: 'Test Running...',
        description: 'Executing workflow with test data...'
      };
      
      this.testSteps = [];
      
      // Call real API
      try {
        const testResult = await this.callTestApi();
        this.displayTestResults(testResult);
      } catch (error) {
        this.displayTestError(error);
      }
    },
    
    calculateDuration() {
      if (!this.testStartTime) return '0s';
      
      const durationMs = Date.now() - this.testStartTime;
      const durationSeconds = (durationMs / 1000).toFixed(1);
      return `${durationSeconds}s`;
    },
    
    displayTestResults(testResult) {
      // Update current test with results
      this.currentTest.status = testResult.status === 'success' ? 'success' : 'failed';
      this.currentTest.duration = this.calculateDuration();
      
      // Display node executions as steps
      if (testResult.nodeExecutions && testResult.nodeExecutions.length > 0) {
        this.testSteps = testResult.nodeExecutions.map(node => ({
          title: node.nodeName || node.nodeId,
          description: node.output || node.status || 'Executed',
          status: node.status === 'success' ? 'success' : node.status === 'failed' ? 'failed' : 'success'
        }));
      }
      
      // Update overall status
      if (testResult.status === 'success') {
        this.overallStatus = null;
      } else if (testResult.status === 'failure') {
        this.overallStatus = {
          type: 'error',
          title: 'Workflow Test Failed',
          description: testResult.error || 'Workflow test run has a critical failure.'
        };
      } else if (testResult.status === 'partial') {
        this.overallStatus = {
          type: 'warning',
          title: 'Workflow Test Partially Completed',
          description: 'Some nodes failed during execution.'
        };
      }
      
      // Display warnings if any
      if (testResult.warnings && testResult.warnings.length > 0) {
        console.warn('Test warnings:', testResult.warnings);
      }
      
      // Add test to history
      this.testHistory.unshift({
        timestamp: this.currentTest.timestamp,
        type: 'test',
        status: this.currentTest.status,
        duration: this.currentTest.duration
      });
    },
    
    displayTestError(error) {
      this.currentTest.status = 'failed';
      this.currentTest.duration = this.calculateDuration();
      
      this.overallStatus = {
        type: 'error',
        title: 'Test Execution Error',
        description: error.message || 'Failed to execute workflow test.'
      };
      
      // Add failed test to history
      this.testHistory.unshift({
        timestamp: this.currentTest.timestamp,
        type: 'test',
        status: 'failed',
        duration: this.currentTest.duration
      });
    },
    
    viewTestDetails(test) {
      // If test has an ID, load instance details from API
      if (test.id) {
        this.viewInstanceDetails(test);
      } else {
        // Otherwise just switch to test run tab
        this.activeTab = 'testRun';
        console.log('View details for test:', test);
      }
    },
    
    /**
     * Load all workflow instances from API
     * Called when Log View tab is opened
     * Uses server-side pagination with query parameters: page, limit, status, patient_id
     */
    async loadWorkflowInstances() {
      try {
        this.isLoadingInstances = true;
        const workflowId = this.$route.params.workflowId;

        if (!workflowId) {
          console.error('No workflow ID found');
          return;
        }

        // Import API function
        const { getAllWorkflowInstancesApi } = await import('@/api/workflowManage');

        // Build query parameters for pagination
        const params = {
          page: this.currentPage,
          limit: this.itemsPerPage
        };

        // Add optional filters
        if (this.filters.status && this.filters.status !== 'all') {
          // Map filter status to API status
          if (this.filters.status === 'success') {
            params.status = 'completed';
          } else if (this.filters.status === 'failed') {
            params.status = 'failed';
          } else {
            params.status = this.filters.status;
          }
        }

        // TODO: Add patient_id filter if needed
        // if (this.patientId) {
        //   params.patient_id = this.patientId;
        // }

        console.log('Loading workflow instances with params:', params);

        // Call API with query parameters
        const response = await getAllWorkflowInstancesApi(workflowId, params);

        // Parse response - instances are nested under response.data.instances
        const rawInstances = response.data?.instances || [];

        // Get total count from API for pagination
        this.totalInstances = response.data?.total || rawInstances.length || 0;

        // Transform instances to match template expectations
        this.workflowInstances = rawInstances.map(instance => ({
          ...instance,
          // Add timestamp field (formatted from started_at)
          timestamp: this.formatTimestamp(instance.started_at || instance.created_at),
          // Determine type: all instances from this API are 'live' runs (triggered by events)
          type: 'live',
          // Normalize status for CSS classes (completed->success, failed->failed, etc.)
          status: this.normalizeStatus(instance.status),
          // Calculate duration
          duration: this.calculateInstanceDuration(instance)
        }));

        console.log('Loaded workflow instances:', this.workflowInstances);
        console.log('Total instances:', this.totalInstances);
      } catch (error) {
        console.error('Error loading workflow instances:', error);

        // Show error notification if available
        if (this.notify) {
          this.notify({
            title: 'Error',
            message: 'Failed to load workflow instances. The API may not be ready yet.',
            type: 'error',
            duration: 3000
          });
        }

        // Set empty array on error
        this.workflowInstances = [];
        this.totalInstances = 0;
      } finally {
        this.isLoadingInstances = false;
      }
    },
    
    /**
     * View instance details
     * Switches to Test Run tab and loads instance details
     */
    async viewInstanceDetails(instance) {
      try {
        // Clear previous test data
        this.clearTestData();
        
        // Switch to Test Run tab
        this.activeTab = 'testRun';
        
        // Immediately show instance data from the list (already has correct status and duration)
        this.currentTest = {
          timestamp: instance.timestamp || this.formatTimestamp(instance.started_at || instance.created_at),
          type: instance.type || 'live',
          status: instance.status, // Use the already-normalized status from the list
          duration: instance.duration || this.calculateInstanceDuration(instance)
        };
        
        // Show loading message for additional details
        this.overallStatus = {
          type: 'running',
          title: 'Loading Instance Details...',
          description: 'Fetching execution details from server...'
        };
        
        this.testSteps = [];
        
        // Import API function
        const { getWorkflowInstanceByIdApi } = await import('@/api/workflowManage');
        
        // Call API to get additional instance details (execution steps, etc.)
        const response = await getWorkflowInstanceByIdApi(instance.id);
        const instanceDetails = response.data || response;
        
        console.log('Instance details:', instanceDetails);
        
        // Display additional instance details (steps, error messages, etc.)
        this.displayInstanceDetails(instanceDetails, instance);
      } catch (error) {
        console.error('Error loading instance details:', error);
        
        this.currentTest.status = 'failed';
        this.currentTest.duration = 'N/A';
        
        this.overallStatus = {
          type: 'error',
          title: 'Failed to Load Instance',
          description: error.message || 'Could not retrieve instance details. The API may not be ready yet.'
        };
        
        if (this.notify) {
          this.notify({
            title: 'Error',
            message: 'Failed to load instance details',
            type: 'error',
            duration: 3000
          });
        }
      }
    },
    
    /**
     * Display instance details in Test Run tab
     * Only adds execution steps and error messages - does NOT override currentTest data
     */
    displayInstanceDetails(instanceDetails, originalInstance) {
      // Do NOT override currentTest - it already has the correct data from the list
      
      // Display node executions as steps
      if (instanceDetails.nodeExecutions && instanceDetails.nodeExecutions.length > 0) {
        this.testSteps = instanceDetails.nodeExecutions.map(node => ({
          title: node.nodeName || node.nodeId || 'Unknown Node',
          description: node.output || node.status || 'Executed',
          status: this.normalizeStatus(node.status)
        }));
      } else if (instanceDetails.steps && instanceDetails.steps.length > 0) {
        this.testSteps = instanceDetails.steps.map(step => ({
          title: step.name || step.stepName || 'Step',
          description: step.description || step.output || 'Executed',
          status: this.normalizeStatus(step.status)
        }));
      }
      
      // Update overall status based on instance status
      const status = this.normalizeStatus(instanceDetails.status);
      
      if (status === 'success') {
        // Show success notification
        this.overallStatus = {
          type: 'success',
          title: 'Workflow Execution Completed',
          description: 'The workflow executed successfully.'
        };
      } else if (status === 'failed') {
        // Show error notification
        this.overallStatus = {
          type: 'error',
          title: 'Workflow Execution Failed',
          description: instanceDetails.error || instanceDetails.errorMessage || 'Workflow execution encountered an error.'
        };
      } else if (status === 'running') {
        // Show running animation
        this.overallStatus = {
          type: 'running',
          title: 'Workflow Running',
          description: 'This workflow instance is currently executing.'
        };
      } else {
        // For other statuses (pending, paused, waiting, cancelled), clear the message
        this.overallStatus = null;
      }
    },
    
    /**
     * Normalize status from API to component status
     * Maps backend status to display status:
     * - completed -> success
     * - failed -> failed
     * - running -> running
     * - Other statuses (pending, paused, waiting, cancelled) keep their original name
     */
    normalizeStatus(status) {
      if (!status) return 'pending';
      const statusLower = status.toLowerCase();
      
      // Map completed to success
      if (statusLower === 'completed') return 'success';
      
      // Keep failed as failed
      if (statusLower === 'failed') return 'failed';
      
      // Keep running as running
      if (statusLower === 'running') return 'running';
      
      // For other statuses (pending, paused, waiting, cancelled), return as-is
      return status;
    },
    
    /**
     * Calculate duration from instance timestamps
     */
    calculateInstanceDuration(instance) {
      if (instance.duration) return instance.duration;
      
      // Calculate duration from started_at to completed_at (if completed)
      if (instance.started_at && instance.completed_at) {
        const start = new Date(instance.started_at).getTime();
        const end = new Date(instance.completed_at).getTime();
        const durationMs = end - start;
        const durationSeconds = (durationMs / 1000).toFixed(1);
        return `${durationSeconds}s`;
      }
      
      // Calculate duration from started_at to updated_at (for running/failed instances)
      if (instance.started_at && instance.updated_at) {
        const start = new Date(instance.started_at).getTime();
        const end = new Date(instance.updated_at).getTime();
        const durationMs = end - start;
        const durationSeconds = (durationMs / 1000).toFixed(1);
        return `${durationSeconds}s`;
      }
      
      return 'N/A';
    },
    
    /**
     * Format timestamp for display
     */
    formatTimestamp(timestamp) {
      if (!timestamp) return 'N/A';
      
      try {
        const date = new Date(timestamp);
        return date.toLocaleString('en-US', { 
          month: '2-digit', 
          day: '2-digit', 
          year: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit' 
        });
      } catch (error) {
        return timestamp;
      }
    },
    
    /**
     * Get status label for display
     * Maps status to display text:
     * - completed/success -> Success
     * - failed -> Failed
     * - running -> Running
     * - Other statuses -> Capitalized (Pending, Paused, Waiting, Cancelled)
     */
    getStatusLabel(status) {
      if (!status) return 'Unknown';
      const statusLower = status.toLowerCase();
      
      // Map completed to Success
      if (statusLower === 'completed' || statusLower === 'success') return 'Success';
      
      // Map failed to Failed
      if (statusLower === 'failed') return 'Failed';
      
      // Map running to Running
      if (statusLower === 'running') return 'Running';
      
      // For other statuses, capitalize first letter
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
    
    /**
     * Clear test data
     * Called before loading new test data (from Run Test or View Details)
     */
    clearTestData() {
      this.currentTest = null;
      this.overallStatus = null;
      this.testSteps = [];
      this.testStartTime = null;
    }
  }
};
</script>

<style scoped>
/* Test Panel */
.test-panel {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  background: #FFFFFF;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px 1px 15px 0px rgba(164, 164, 164, 0.25);
  transition: all 0.3s;
}

.test-panel.collapsed {
  height: 30px;
}

.test-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background: linear-gradient(90deg, #E6EDF2 0%, #EAF8F9 100%);
  border-radius: 10px 10px 0 0;
}

.test-panel.collapsed .test-panel-header {
  justify-content: end;
  padding: 6px 24px;
}

.test-panel-title-section {
  display: flex;
  align-items: center;
  gap: 4px;
}

.workflow-icon-small {
  width: 24px;
  height: 24px;
  background: #20A7C1;
  border-radius: 50%;
}

.test-panel-title {
  font-family: 'Lato', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.2px;
  color: #004879;
}

.collapse-btn {
  width: 18px;
  height: 18px;
  padding: 2px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.test-panel-content {
  padding: 24px;
  max-height: 550px;
  overflow-y: auto;
}

.test-panel-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
  margin: 0;
}

/* Tabs */
.tabs-container {
  display: flex;
  border-bottom: 1px solid #E6E6E6;
  padding: 0 8px;
  margin-bottom: 12px;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 16px;
  background: #FFFFFF;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #666666;
  transition: all 0.2s;
}

.tab-button.active {
  border-bottom-color: #004879;
  color: #004879;
}

.tab-button:hover {
  background: #F9FBFD;
}

/* Test Run Tab */
.test-run-tab {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.test-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666666;
  text-align: center;
  padding: 0 24px;
  margin: 0;
}

/* Current Test Status */
.current-test-status {
  padding: 8px 24px;
}

.status-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-timestamp {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #333333;
  text-align: center;
}

.status-chip {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.status-chip.live {
  background: #E1D3F1;
  color: #6F4999;
}

.status-chip.test {
  background: #E4F3F5;
  color: #004879;
}

.status-result {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.status-result.running {
  color: #374957;
}

.status-result.success {
  color: #45960D;
}

.status-result.failed {
  color: #D10000;
}

.status-duration {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
  text-align: center;
}

/* Test Steps Container */
.test-steps-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
}

/* Status Message */
.status-message {
  padding: 12px 16px;
  border-radius: 8px;
}

.status-message.running {
  background: #E8F4FD;
}

.status-message.error {
  background: #FAEAEA;
}

.status-message-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-message-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-message-title {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin: 0;
}

.status-message.running .status-message-title {
  color: #333333;
}

.status-message.error .status-message-title {
  color: #D10000;
}

.status-message-description {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  margin: 0;
}

.status-message.running .status-message-description {
  color: #666666;
}

.status-message.error .status-message-description {
  color: #D10000;
}

.divider {
  height: 1px;
  background: #C4C4C4;
  width: 100%;
}

/* Test Steps List */
.test-steps-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
}

.test-step {
  padding: 12px 16px;
  border-radius: 8px;
}

.test-step.running {
  background: #E8F4FD;
}

.test-step.success {
  background: #F1F9F5;
}

.test-step.failed {
  background: #FAEAEA;
}

.step-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-icon {
  flex-shrink: 0;
}

.step-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.step-title {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin: 0;
}

.test-step.running .step-title,
.test-step.success .step-title {
  color: #333333;
}

.test-step.failed .step-title {
  color: #D10000;
}

.step-description {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  margin: 0;
}

.test-step.running .step-description,
.test-step.success .step-description {
  color: #666666;
}

.test-step.failed .step-description {
  color: #D10000;
}

/* Spinning Animation */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinning {
  animation: spin 1s linear infinite;
}

/* Log View Tab */
.log-view-tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Filters */
.filters-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.filter-group {
  flex: 1;
}

.items-per-page {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* Test History Table */
.test-history-table {
  display: flex;
  flex-direction: column;
  background: #F9FBFD;
  border-radius: 4px;
}

.table-header {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #E6E6E6;
  border-radius: 4px 4px 0 0;
}

.table-body {
  display: flex;
  flex-direction: column;
}

.table-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #E6E6E6;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background: #F0F0F0;
}

.table-cell {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #333333;
}

.table-cell.timestamp {
  flex: 1;
  text-align: center;
}

.table-cell.test-type {
  flex: 1;
  display: flex;
  justify-content: center;
}

.table-cell.status {
  flex: 1;
  display: flex;
  justify-content: center;
}

.table-cell.duration {
  flex: 1;
  text-align: center;
}

.table-cell.details {
  flex: 1;
  display: flex;
  justify-content: center;
}

.type-chip {
  padding: 2px 8px;
  border-radius: 999px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.type-chip.live {
  background: #E1D3F1;
  color: #6F4999;
}

.type-chip.test {
  background: #E4F3F5;
  color: #004879;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.status-indicator.running {
  color: #374957;
}

.status-indicator.success {
  color: #45960D;
}

.status-indicator.failed {
  color: #D10000;
}

.view-details-btn {
  padding: 4px 12px;
  background: transparent;
  border: none;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #004879;
  cursor: pointer;
  text-decoration: underline;
}

.view-details-btn:hover {
  color: #003A5D;
}

/* Pagination */
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.pagination-btn:hover:not(:disabled) {
  background: #E6E6E6;
}

.pagination-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.pagination-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  border-radius: 4px;
}

.pagination-number:hover {
  background: #E6E6E6;
}

.pagination-number.active {
  background: #004879;
  color: #FFFFFF;
}

.pagination-ellipsis {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #333333;
}
</style>
